
import { StoreEntityType } from 'ngx-unificator/store';

export interface SpinWheelStore {
  bonusApproved?: boolean;
  currentBonus?: {
    index: number;
    name: string;
    value: string;
    segment: string;
  };
  bonusApprovedTime?: any;
  bonusList?: {
    index: number;
    name: string;
    value: string;
    segment: string;
  }[]
}

export const spinWheelStore: StoreEntityType<SpinWheelStore> = {
  bonusApproved: null,
  currentBonus: null,
  bonusApprovedTime: null,
  bonusList: [],
  __system: {
    persistence: 'localStorage'
  }
};

export type SpinWheelStoreEntity = typeof spinWheelStore;
